import React from 'react';
import { connect } from 'react-redux';
import TableC from '../../basicElement/TableC';
import ExportModal from './ExportModal';
import ExportDataModal from './ExportDataModal';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import Filter from './Filter';
import moment from 'moment';
import { actions } from './store';

const monthFormat = 'YYYY-MM';
const currentDate = moment().format(monthFormat)

class Query extends React.Component {
    constructor(props) {
        super(props);
        const { useState, searchParams: propSearchParams, pagination: propPagination } = props;
        let searchParams = {
            oper: 'GT',
            startDate: currentDate,
            endDate: currentDate,
        };
        let pagination = {
            pageSize: 10,
            current: 1,
        };
        if (useState) {
            searchParams = {
                ...searchParams,
                ...propSearchParams,
            };
            pagination = {
                ...pagination,
                ...propPagination,
            };
        }
        this.state = {
            searchParams,
            sortParams: {},
            data: [],
            pagination,
            loading: false,
        };
    }

    componentDidMount() {
        const { clearState, updateClearState } = this.props;
        this.loadData();
        if (!clearState) updateClearState();
    }

    componentWillUnmount() {
        const { clearState, useState, saveSearchParams, savePagination, updateUseState } = this.props;
        if (clearState) {
            saveSearchParams({});
            savePagination({});
        }
        if (useState) updateUseState();
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { areaParams = {}, hasCheckedArea, ...rest } = searchParams;
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.manhour.queryManHourRecord,
            data: {
                limit: pageSize - 1,
                offset: current,
                ...sortParams,
                ...areaParams,
                ...rest,
            },
            type: 'json',
            doneResult: res => {
                const { pagination } = this.state;
                const { datas, totalCount } = res;
                pagination.total = totalCount + Math.ceil(totalCount / (pageSize - 1));
                        
                this.setState({
                    pagination,
                    loading: false,
                    data: datas,
                });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        this.setState({
            pagination: {
                pageSize: 10,
                current: 1,
            },
        }, () => {
            this.loadData();
        });
    }

    handleSearchChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams } });
    }

    export = () => {
       this.exportRef.show();
    }

    exportData = () => {
        this.exportDataRef.show();
    }

    getColumns = () => [{
        title: '工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        sorter: 'true',
        sortType: 'common',
        width: 100,
        fixed: 'left',
    }, {
        title: '姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        sorter: 'true',
        sortType: 'common',
        width: 100,
        fixed: 'left',
    }, {
        title: '区域',
        dataIndex: 'areaName',
        key: 'areaName',
        width: 100,
    }, {
        title: '工作城市',
        dataIndex: 'workCityName',
        key: 'workCityName',
        sorter: 'true',
        sortType: 'common',
        width: 100,
    }, {
        title: '职位',
        dataIndex: 'positionName',
        key: 'positionName',
        width: 100,
    }, {
        title: '所属部门',
        dataIndex: 'enterpriseDepartmentName',
        key: 'enterpriseDepartmentName',
        width: 100,
    }, {
        title: '直线主管',
        dataIndex: 'leaderName',
        key: 'leaderName',
        width: 80,
    }, {
        title: '目前状态',
        dataIndex: 'statusStr',
        key: 'statusStr',
        width: 80,
    }, {
        title: '项目实时FTE',
        dataIndex: 'invActualFte',
        key: 'invActualFte',
        sortType: 'common',
        width: 120,
        sorter: 'true',
    }, {
        title: '项目确认FTE',
        dataIndex: 'invConfirmFte',
        key: 'invConfirmFte',
        sortType: 'common',
        sorter: 'true',
        width: 120,
    }, {
        title: '非项目实时FTE',
        dataIndex: 'otherActualFte',
        key: 'otherActualFte',
        sorter: 'true',
        sortType: 'common',
        width: 120,
    }, {
        title: '非项目确认FTE',
        dataIndex: 'otherConfirmFte',
        key: 'otherConfirmFte',
        sorter: 'true',
        sortType: 'common',
        width: 120,
    }, {
        title: '总FTE',
        dataIndex: 'totalConfirmFte',
        key: 'totalConfirmFte',
        width: 80,
    }, {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        sort: 'true',
        sortType: 'common',
        width: 140,
        fixed: 'right',
        render: (text, record, index) => {
            const { curRole,curEmployeeCode } = sessionStorage;
            const isHRRC = curRole == 'HRRC';
            return (
                record.employeeCode !== '总计' &&
                <div>
                    <a href={`/#/manHour/MyWeeklys/${record.id}`}>查看周工时</a>
                    {
                        !isHRRC && < span className="ant-divider"/>
                    }
                    {
                        !isHRRC && <a onClick={e => this.linkTo(record)}>查看月度FTE</a>
                    }
                </div>
            );
        }
    }]

    linkTo = (record) => {
        const { clearState, saveSearchParams, savePagination, updateClearState } = this.props
        const { searchParams, pagination } = this.state;
        saveSearchParams(searchParams);
        savePagination(pagination);
        if (clearState) updateClearState();
        location.href = `/#/manHour/monthlyFte/${record.id}`;
    }

    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        data.map((manhour, i) => {
            dataSource.push({
                ...manhour,
                key: i,
                id: manhour.userId,
                durationIsTrue: manhour.durationIsTrueTemp,
                durationIsFalse: manhour.durationIsFalseTemp,
                durationTotal: manhour.durationTotalTemp,
                durationIsActual: manhour.employeeCode !== '总计' ? manhour.durationIsActual : manhour.durationIsActualTotal,
                statusStr: (manhour.statusStr && manhour.statusStr.length) > 2 ? <span>{manhour.statusStr.slice(0, 2)}<br/>{manhour.statusStr.slice(2)}</span>: manhour.statusStr,
            })
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { pagination, loading, sortParams, searchParams } = this.state
        const yscroll = document.documentElement.clientHeight - 460;
        return (
            <div className="content">
                <SideNav selectKey="query" />
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                        exportData={this.exportData}
                        searchParams={searchParams}
                        onChange={this.handleSearchChange}
                    />
                    <TableC
                        loading={loading}
                        // scrollY={yscroll}
                        sortParams={sortParams}
                        pagination={pagination}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        onChange={this.handleTableChange}
                    />
                    <ExportModal ref={el => this.exportRef = el} pagination={pagination} searchParams={searchParams} />
                    <ExportDataModal ref={el => this.exportDataRef = el} pagination={pagination} searchParams={searchParams} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    ...state.manHourState.query
});

export default connect(mapStateToProps, actions)(Query);



// WEBPACK FOOTER //
// ./src/components/manHour/query/index.js